<script>
  // The shell every job card sits in.
  //
  // The five FileCard components each carried their own copy of the same
  // markup: a `card shadow-lg p-5 mt-4 mb-1 bg-base-300` wrapper and a
  // `grid grid-cols-2 justify-items-stretch` header. Grey cards on a grey slab
  // inside a light page meant three shades of grey stacked on each other and no
  // status signal anywhere.
  //
  // Shared with the sibling RIC BGO Tool -- keep the two in step.
  import StatusBadge from "./StatusBadge.svelte";
  import { statusMeta } from "../../lib/status.js";

  export let id;
  export let title;
  export let status;
  /** Overrides the badge text -- the Busy card shows the solver's phase. */
  export let statusLabel = null;
  export let live = false;
  /** [{label, value}] rendered as a two-column definition list. */
  export let meta = [];

  $: rail = statusMeta(status).rail;
</script>

<article class="surface surface-hover rail p-4 pl-5" style="--rail: {rail}">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <div class="flex items-center gap-2">
        <StatusBadge {status} {live} label={statusLabel} />
        <span class="font-mono text-xs opacity-50">#{id}</span>
      </div>
      <h3 class="mt-1.5 break-words text-base font-semibold leading-snug">
        {title}
      </h3>
    </div>

    <!-- shrink-0: long scenario codes used to squeeze the action buttons into
         a vertical stack. -->
    <div class="flex shrink-0 items-center gap-1.5">
      <slot name="actions" />
    </div>
  </div>

  {#if meta.length}
    <dl class="mt-3 grid gap-x-8 gap-y-1 text-sm sm:grid-cols-2">
      {#each meta as item (item.label)}
        <div class="flex min-w-0 gap-1.5">
          <dt class="shrink-0 opacity-50">{item.label}</dt>
          <dd class="truncate" title={item.value}>{item.value}</dd>
        </div>
      {/each}
    </dl>
  {/if}

  <slot />
</article>
